import {  createSlice } from "@reduxjs/toolkit";
import {  stateEnum } from "../constants/enum"
const { jvEntry } = stateEnum

const initialState = {

    detailParams: {},
    isNewEntry: false,
}


const journalVoucherSlice = createSlice({
    name: jvEntry,
    initialState,
    reducers: {
        resetDetailParams: (state) => {
            state.detailParams = {}
            state.isNewEntry = true
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
        },
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload
        },

    },
})

export const { resetDetailParams, setNewEntryMode, setDetailParams } = journalVoucherSlice.actions

export default journalVoucherSlice.reducer

